import Loadable from '@townsquare/loadable';

export const EditAgentLoadable = Loadable({
	loader: () => import(/* webpackChunkName: "edit-agent-view" */ './EditAgentView'),
	loading: () => null,
});
